import * as React from 'react';

// STYLES
import * as Style from "./TablePaginationStyle";

// LIBRARIES

// MISC
import { IProps } from './TablePaginationModel';

// ASSETS

// REDUX

// COMPONENTS


const Pagination = (props: IProps) => {
    
    // PROPS
    const {totalPage = 0, currentPage = 0, onChange = () => {}} = props

    // CONSTANTS USING LIBRARIES

    // CONSTANTS USING HOOKS

    // GENERAL CONSTANTS

    // USE EFFECT FUNCTION
        
    // REQUEST API FUNCTIONS

    // HANDLERS FUNCTIONS

    return <Style.PaginationContainer>
        <Style.TablePagination
                componentName='div'
                size='large'
                count={totalPage}
                siblingCount={0}
                page={currentPage + 1}
                onChange={(event, newPage) => onChange(event, newPage)}
            />
    </Style.PaginationContainer >;
};

export default Pagination;